<template>
  <div class="cw-accordion">
    <button
      class="cw-accordion--title drag-handle btn-primary"
      :class="{ 'is-open': isOpen }"
      @click="$emit('click')"
    >
      <div class="cw-accordion--title-wrap">
        <proto-icon
          v-if="protoIcon"
          class="proto-sec-ic"
          :name="protoIcon"
          size="15"
        />
        <emoji-or-icon
          v-else
          class="icon-or-emoji"
          :icon="icon"
          :emoji="emoji"
        />
        <h5>
          {{ title }}
        </h5>
      </div>
      <div class="button-icon--wrap">
        <slot name="button" />
        <div class="chevron-icon__wrap">
          <fluent-icon v-if="isOpen" size="24" icon="subtract" type="solid" />
          <fluent-icon v-else size="24" icon="add" type="solid" />
        </div>
      </div>
    </button>
    <div
      v-show="isOpen"
      class="cw-accordion--content"
      :class="{ compact: compact }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import EmojiOrIcon from 'shared/components/EmojiOrIcon';
import ProtoIcon from 'shared/components/ProtoIcon';

export default {
  components: {
    EmojiOrIcon,
    ProtoIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    emoji: {
      type: String,
      default: '',
    },
    protoIcon: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.cw-accordion {
  // This is done to fix contact sidebar border issues
  // If you are using it else, find a fix to remove this hack
  margin-top: -1px;
  font-size: var(--font-size-small);
}
.cw-accordion--title {
  align-items: center;
  background: var(--white);
  border-bottom: 1px solid var(--s-75);
  border-top: 1px solid var(--s-75);
  cursor: grab;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: var(--space-slab) var(--space-normal);
  user-select: none;
  width: 100%;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: var(--s-25);
  }

  // Aberto: some a linha de baixo (header flui direto no conteúdo, igual ao protótipo)
  &.is-open {
    border-bottom-color: transparent;
  }

  h5 {
    font-size: var(--font-size-mini);
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--s-500);
    margin-bottom: 0;
    padding: 0 var(--space-small) 0 0;
  }
}

.cw-accordion--title-wrap {
  display: flex;
  align-items: center;
  gap: var(--space-smaller);
  margin-bottom: 0;
}

// Traço/fill vêm do próprio ProtoIcon; aqui só a cor do header de seção.
.proto-sec-ic {
  color: var(--s-500);
}

.title-icon__wrap {
  display: flex;
  align-items: baseline;
}

.icon-or-emoji {
  display: inline-block;
  width: var(--space-two);
}

.button-icon--wrap {
  display: flex;
  flex-direction: row;
}

.chevron-icon__wrap {
  display: flex;
  justify-content: flex-end;
  width: var(--space-slab);
  color: var(--g-20);
}

.cw-accordion--content {
  padding: var(--space-normal);

  &.compact {
    padding: 0;
  }
}
</style>
